import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Wrapper } from '@googlemaps/react-wrapper';
import { Component, StrictMode } from 'react';
import { resetMovie, switchMovie } from '../actions';
import store from '../store';
import updateMarkers from '../tools/updateMarkers';
import ErrorBubble from './ErrorBubble';
import MoviesMap from './MoviesMap';
import MovieSelector from './Selector';
class SomeApp extends Component {
    constructor(props) {
        super(props);
        this.componentDidMount = () => window.addEventListener('popstate', this.popStateHandler);
        this.componentWillUnmount = () => window.removeEventListener('popstate', this.popStateHandler);
        this.popStateHandler = (event) => this.dispatchChange(event.state ? event.state.title : '', true);
        props.init();
    }
    dispatchChange(title, loadingHistory) {
        store.dispatch(title ? switchMovie(title, loadingHistory) : resetMovie(loadingHistory));
    }
    render() {
        return (_jsxs(StrictMode, { children: [_jsx(ErrorBubble, { message: this.props.error }), _jsx(MovieSelector, { titles: this.props.titles, className: "title-select", handleChange: this.dispatchChange, value: this.props.movieTitle, loadingData: this.props.loadingData }), _jsx(Wrapper, { apiKey: `${process.env.REACT_APP_GMAPS_API_KEY}`, children: _jsx(MoviesMap, { locations: this.props.locations, movieTitle: this.props.movieTitle, loadingLocations: this.props.loadingLocations, updateMarkers: updateMarkers }) })] }));
    }
}
export default SomeApp;
